(function () {
  const timers = new WeakMap();
  const storagePrefix = 'ysn_cart_drawer_timer_end_';
  const addonDeclinedKey = 'ysn_cart_drawer_addon_declined_';
  const addonAutoAddedKey = 'ysn_cart_drawer_addon_auto_added_';

  function pad(value) {
    return String(value).padStart(2, '0');
  }

  function getEndTime(el) {
    const duration = Math.max(1, parseInt(el.dataset.durationMinutes || '10', 10));
    const key = storagePrefix + duration;
    const now = Date.now();
    let end = 0;

    try {
      end = parseInt(sessionStorage.getItem(key) || '0', 10);
    } catch (e) {
      end = 0;
    }

    if (!end || end <= now) {
      end = now + duration * 60 * 1000;
      try { sessionStorage.setItem(key, String(end)); } catch (e) {}
    }

    return end;
  }

  function updateTimer(el) {
    const timeEl = el.querySelector('[data-ysn-cart-timer-time]');
    const expiredEl = el.querySelector('[data-ysn-cart-timer-expired]');
    const messageEl = el.querySelector('.ysn-cart-drawer-timer__message');
    if (!timeEl) return;

    const end = getEndTime(el);
    const remaining = Math.max(0, end - Date.now());

    if (remaining <= 0) {
      if (messageEl) messageEl.hidden = true;
      if (expiredEl) expiredEl.hidden = false;
      el.classList.add('ysn-cart-drawer-banner--expired');
      return;
    }

    const totalSeconds = Math.ceil(remaining / 1000);
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    timeEl.textContent = minutes + ':' + pad(seconds);
  }

  function initTimers() {
    document.querySelectorAll('[data-ysn-cart-timer]').forEach(function (el) {
      if (timers.has(el)) return;
      updateTimer(el);
      timers.set(el, window.setInterval(function () { updateTimer(el); }, 1000));
    });
  }

  function getSectionIds() {
    const ids = new Set();
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (component) {
      if (component.dataset.sectionId) ids.add(component.dataset.sectionId);
    });
    return Array.from(ids);
  }

  function dispatchCartUpdate(cart) {
    document.dispatchEvent(new CustomEvent('cart:update', {
      bubbles: true,
      detail: {
        resource: cart,
        data: {
          itemCount: cart.item_count,
          sections: cart.sections || {},
          source: 'ysn-cart-drawer-advanced'
        }
      }
    }));
  }


  function cartJsonUrl() {
    const base = Theme.routes.cart_url || '/cart';
    return base.endsWith('.js') ? base : base + '.js';
  }

  function findLineKeyByVariant(variantId) {
    return fetch(cartJsonUrl(), { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        const target = String(variantId);
        const addonLine = (cart.items || []).find(function (item) {
          return String(item.variant_id) === target && item.properties && item.properties._ysn_cart_addon === 'true';
        });
        const anyLine = addonLine || (cart.items || []).find(function (item) {
          return String(item.variant_id) === target;
        });
        return anyLine ? anyLine.key : variantId;
      })
      .catch(function () { return variantId; });
  }

  function cartRequest(type, variantId, options) {
    options = options || {};
    const sections = getSectionIds();
    const baseBody = {
      sections: sections.join(','),
      sections_url: window.location.pathname
    };

    let url = Theme.routes.cart_add_url;
    const item = { id: Number(variantId), quantity: 1 };
    if (options.properties) item.properties = options.properties;
    let body = Object.assign({}, baseBody, {
      items: [item]
    });

    if (type === 'remove') {
      url = Theme.routes.cart_change_url;
      body = Object.assign({}, baseBody, {
        id: options.lineKey || Number(variantId),
        quantity: 0
      });
    }

    return fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(body)
    }).then(function (response) {
      if (!response.ok) throw new Error('Cart request failed');
      return response.json();
    }).then(function (cart) {
      dispatchCartUpdate(cart);
      window.setTimeout(initTimers, 50);
      return cart;
    });
  }

  function setButtonLoading(button, loading) {
    const text = button.querySelector('span:last-child') || button;
    if (loading) {
      button.dataset.originalHtml = button.innerHTML;
      button.disabled = true;
      if (text) text.textContent = button.dataset.addingText || 'Adding...';
      button.classList.add('is-loading');
    } else {
      if (button.dataset.originalHtml) button.innerHTML = button.dataset.originalHtml;
      button.disabled = false;
      button.classList.remove('is-loading');
    }
  }

  function syncUpsellVisibility() {
    return fetch(cartJsonUrl(), { headers: { 'Accept': 'application/json' } })
      .then(function (response) { return response.json(); })
      .then(function (cart) {
        const productIds = new Set((cart.items || []).map(function (item) { return String(item.product_id); }));
        document.querySelectorAll('[data-ysn-cart-upsells]').forEach(function (section) {
          let visibleCount = 0;
          section.querySelectorAll('[data-ysn-upsell-card]').forEach(function (card) {
            const shouldHide = productIds.has(String(card.dataset.productId));
            card.hidden = shouldHide;
            card.classList.toggle('is-cart-hidden', shouldHide);
            if (!shouldHide) visibleCount += 1;
          });
          section.hidden = visibleCount === 0;
          section.classList.toggle('is-single', visibleCount === 1);
        });
      })
      .catch(function () {});
  }

  function initAddonDefault() {
    document.querySelectorAll('[data-ysn-cart-addon][data-default-on="true"]').forEach(function (addon) {
      const toggle = addon.querySelector('[data-ysn-addon-toggle]');
      const variantId = addon.dataset.variantId;
      if (!toggle || !variantId) return;
      if (toggle.getAttribute('aria-checked') === 'true') {
        try { sessionStorage.setItem(addonAutoAddedKey + variantId, '1'); } catch (e) {}
        return;
      }

      try {
        if (sessionStorage.getItem(addonDeclinedKey + variantId) === '1') return;
        if (sessionStorage.getItem(addonAutoAddedKey + variantId) === '1') return;
        sessionStorage.setItem(addonAutoAddedKey + variantId, '1');
      } catch (e) {}

      addon.dataset.autoAdding = 'true';
      cartRequest('add', variantId, { properties: { _ysn_cart_addon: 'true' } }).catch(function () {}).finally(function () {
        delete addon.dataset.autoAdding;
      });
    });
  }

  document.addEventListener('click', function (event) {
    const addButton = event.target && event.target.closest ? event.target.closest('[data-ysn-cart-add]') : null;
    if (addButton) {
      event.preventDefault();
      const variantId = addButton.dataset.variantId;
      const card = addButton.closest('[data-ysn-upsell-card]');
      if (!variantId || addButton.disabled) return;

      setButtonLoading(addButton, true);
      cartRequest('add', variantId).then(function () {
        if (card) card.classList.add('is-removing');
        window.setTimeout(syncUpsellVisibility, 120);
      }).catch(function () {
        setButtonLoading(addButton, false);
      });
      return;
    }

    const toggle = event.target && event.target.closest ? event.target.closest('[data-ysn-addon-toggle]') : null;
    if (toggle) {
      event.preventDefault();
      const addon = toggle.closest('[data-ysn-cart-addon]');
      const variantId = toggle.dataset.variantId;
      if (!addon || !variantId || toggle.disabled) return;

      const isActive = toggle.getAttribute('aria-checked') === 'true';
      toggle.disabled = true;
      addon.classList.add('is-loading');

      if (isActive) {
        try { sessionStorage.setItem(addonDeclinedKey + variantId, '1'); } catch (e) {}
      } else {
        try { sessionStorage.removeItem(addonDeclinedKey + variantId); } catch (e) {}
      }

      const request = isActive
        ? findLineKeyByVariant(variantId).then(function (lineKey) { return cartRequest('remove', variantId, { lineKey: lineKey }); })
        : cartRequest('add', variantId, { properties: { _ysn_cart_addon: 'true' } });

      request.catch(function () {
        toggle.disabled = false;
        addon.classList.remove('is-loading');
      });
      return;
    }

    const prev = event.target && event.target.closest ? event.target.closest('[data-ysn-upsell-prev]') : null;
    const next = event.target && event.target.closest ? event.target.closest('[data-ysn-upsell-next]') : null;
    if (prev || next) {
      event.preventDefault();
      const section = event.target.closest('[data-ysn-cart-upsells]');
      const rail = section && section.querySelector('[data-ysn-upsell-rail]');
      if (!rail) return;
      const amount = Math.max(180, Math.round(rail.clientWidth * 0.82));
      rail.scrollBy({ left: next ? amount : -amount, behavior: 'smooth' });
    }
  });

  document.addEventListener('DOMContentLoaded', function () {
    initTimers();
    initAddonDefault();
    syncUpsellVisibility();
  });
  document.addEventListener('cart:update', function () {
    window.setTimeout(function () {
      initTimers();
      initAddonDefault();
      syncUpsellVisibility();
    }, 100);
  });
  document.addEventListener('ysn:cart-reconciled', function () {
    window.setTimeout(function () {
      initTimers();
      initAddonDefault();
      syncUpsellVisibility();
    }, 50);
  });
  document.addEventListener('cart-drawer:open', function () {
    initTimers();
    initAddonDefault();
    syncUpsellVisibility();
  });
  window.addEventListener('cart-drawer:open', function () {
    initTimers();
    initAddonDefault();
    syncUpsellVisibility();
  });
  window.setInterval(initTimers, 1500);
})();
